import Image from "next/image";
import { useTranslation } from '../../useTranslation';

const style = {
    wrapper: `mx-auto w-full px-8 py-12 lg:py-16`,
    grid: `w-full max-w-7xl mx-auto`,
    image: `relative overflow-hidden`,
    item: `lg:py-24 mx-auto w-full`,
}

const Content2 = () => {

    const t = useTranslation();

    return (
        <section className='echte-nutzerbewertungen'>
            <div className={style.wrapper}>
                <div className={style.grid}>
                    <div className={style.item}>
                        <h2 className="text-center">{t.home_step2_title}</h2>
                        <div className="mt-6 text-center" dangerouslySetInnerHTML={{ __html: t.home_step2_description }}></div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Content2;
